import { DownloadIcon, PdfIcon } from '@/components/atoms/icons';
import IFile from '@/models/viewModels/base/IFile';
import styles from './downloads.module.scss';
import { Link } from '@/navigation';

type Props = {
  files: IFile[];
};

const condenseFileSizeUnit = (size: number): string => {
  if (size === 0) return `0 kB`;
  const k = 1024;
  const sizes = [`Bytes`, `kB`, `MB`, `GB`];
  const i = Math.floor(Math.log(size) / Math.log(k));
  const decimals = i > 1 ? 1 : 0;

  return `${parseFloat((size / k ** i).toFixed(decimals))}${sizes[i]}`;
};

export default function Downloads({ files }: Props) {
  const sortedFiles = files.sort((a, b) => a.displayName.localeCompare(b.displayName));
  return (
    <section id="downloads" className={`${styles.downloads} mt-4`}>
      <div
        className={`${styles[`downloads-content`]} element-default-style bg-white rounded-border-6`}
      >
        <h2 className="m-0">Downloads</h2>
        <div className={`${styles[`downloads-list`]}`}>
          {sortedFiles.map((item) => (
            <Link
              href={item.secureUrl}
              key={item.displayName}
              target="_blank"
              rel="noreferrer"
              className={`${styles.downloads_item} d-flex align-items-lg-center align-items-stretch`}
            >
              <PdfIcon />
              <span className={`${styles.filename}`}>
                {item.displayName}
                {item.format && `.${item.format}`}
                <span className="d-inline mx-1">({condenseFileSizeUnit(item.bytes)})</span>
                <DownloadIcon />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
